export default __webpack_public_path__ + "static/media/google.31621be1.png";